<!-- Disclaimer -->
<mc-window #disclaimerWindow modal="true" title="User Agreement" [width]="820" closable="false">
    <div slot="content" style="height:75vh; overflow:auto; padding:1.143em; margin:-1.143em; max-height: 1225px;">
        <p style="margin-bottom: 1rem;">
            Welcome to One Map.  If you are a first-time user, One Map is a web-based GIS mapping application for accessing highway and bridge project data for the Commonwealth of Pennsylvania; as well as other asset information and boundary layers.  This application is provided by the Pennsylvania Department of Transportation (PennDOT) for use by the public and business partners of the Commonwealth.  We invite you to become a registered user to allow for increased functionality, such as the ability to save and share maps with other registered users.
        </p>
        <p style="margin-bottom: 1rem;">
            For previous users, you will notice the system has gone through a few changes with its update to MapCore 2.0.  Below are a couple new features or changes to the system if you were familiar to One Map prior to February 2020:
        </p>
        <ol style="margin: 0 0 1rem 0; font-size: 1em; max-width: 88%;">
            <li>Upgrade to MapCore 2.0.</li>
            <li>Ability to Multi-Select AOI Regions.  By holding the Ctrl key and clicking on AOI options from a list, you can load more than one AOI into the map (ex. Adams and Franklin Counties).</li>
            <li>Loading bar displays when information is being retrieved.  This will let users know that a selected function is in process and not frozen or disabled.</li>
            <li>All layers now display in single Legend sub-set.  There are no longer categories for Dynamic Layers, External Layers, and Drawing Layers.</li>
            <li>New look to individual layer options drop-down in the legend.  Layer details can now be found in the legend options “gear symbol” rather than a down arrow on the right side of the legend.</li>
            <li>Changes to Theme Editor Tool.  The layer selected for theming is changed instead of creating multiple themed sub-layers.</li>
            <li>Changes to Print Map sequence.  It is now a one-screen process, rather than multiple steps and sequences.</li>
            <li>The Switch Basemap Option is now along the left side of the screen, next to the legend.</li>
        </ol>
        <div class="block-group block-group-2-up">
            <div class="card block trailer-1">
                <figure class="card-image-wrap">
                    <img class="card-image" src="assets/register.png" alt="Register">
                </figure>
                <div class="card-content">
                    <p style="margin: 0;">You can register with the application by clicking on the profile link in the upper right hand corner.</p>
                </div>
            </div>
            <div class="card block trailer-1">
                <figure class="card-image-wrap">
                    <img class="card-image" src="assets/help.png" alt="Access Help">
                </figure>
                <div class="card-content">
                    <p style="margin: 0;">You can also access help documents about the application and a contact us from the information tab.</p>
                </div>
            </div>
        </div>
        <hr style="margin: 15px 0;">
        <p style="margin-bottom: 1rem;">
            All users, not just new users, are encouraged to watch the tutorial video for PennDOT One Map. There is new
            functionality available for users, as well as different workflows. This video will be most helpful for users to
            navigate PennDOT One Map.
        </p>
        <div class="text-center">
            <button class="btn" (click)="tutorialVideo()">Click here to watch the tutorial.</button>
        </div>
        <hr style="margin: 15px 0;">
        <div class="alert alert-yellow is-active" style="margin-bottom: 1rem; max-width: none;">
            Disclaimer:
            <br>
            Any cost-related information or date-related details included on this website are considered estimates; both are
            subject to change at any time by the Department of Transportation.
            <ul style="margin: 5px 0; font-size: 1em;">
                <li>
                    Only projects with a State Route (SR), Segment, and Offset can be mapped in this application.
                </li>
                <li>
                    At this time, local road projects (i.e., locally let) cannot be mapped in this application.
                </li>
            </ul>
        </div>
        <p>
            You must accept the terms of the disclaimer in order to proceed.
        </p>
        <div class="text-right">
            <button class="btn" (click)="acceptDisclaimer()">Accept</button>
        </div>
    </div>
</mc-window>

<!-- Map Catalog -->
<mc-window #mapCatalogWindow modal="true" title="Map Catalog" width="800" height="700">
    <mc-map-catalog #mapCatalog slot="content" show-system-maps="true" show-only-application-user-maps="false" show-user-maps="true" [loggedIn]="loggedIn" (shouldLogIn)="logInOrOut($event)" (ondone)="closeMapCatalog($event)" (onmapopened)="mapOpened($event)"></mc-map-catalog>
</mc-window>

<!-- Map Merge -->
<mc-window #mapMergeWindow modal="true" min-height="200" width="500">
    <mc-merge-map #mapMerge slot="content" include-map-filter="true"></mc-merge-map>
</mc-window>
<!-- Layer Catalog -->
<mc-window #layerCatalogWindow modal="true" title="Layer Catalog"
           is-resizable="true" is-draggable="true" width="760"
           (openChange)="layerCatalogWindowOpenChange($event)">
    <mc-layer-catalog #layerCatalog slot="content" filter-layers-before-add="true" (layersAdded)="layersAddedFromCatalog($event)"></mc-layer-catalog>
</mc-window>

<!-- Share Layer -->
<mc-window #shareLayerWindow id="shareLayerWindow" title="Share Layer" is-draggable="true" is-resizable="true" [width]="800" [maxHeight]="800">
    <mc-share-layer #shareLayer slot="content"></mc-share-layer>
</mc-window>

<!-- Unshare Layer -->
<mc-window #unshareLayerWindow id="unshareLayerWindow" title="Unshare Layer" is-draggable="true" is-resizable="true" [width]="800" [maxHeight]="800">
    <mc-unshare-layer #unshareLayer slot="content"></mc-unshare-layer>
</mc-window>

<!-- Measure Tool -->
<mc-window #measureToolsWindow title="Measure" width="600" top="65" left="175" is-draggable="true" (openChange)="onWindowOpenChange($event)">
    <div slot="content">
        <mc-tabs #tabs tabs='[{"name":"Distance", "active":true},{"name":"Area"},{"name":"Coordinates"}]' (tabChanged)="onTabChanged($event)">
            <div slot="tab_1">
                <mc-distance #distance></mc-distance>
            </div>
            <div slot="tab_2">
                <mc-area #area></mc-area>
            </div>
            <div slot="tab_3">
                <mc-coordinates #coordinates current-mode="capture"></mc-coordinates>
            </div>
        </mc-tabs>
    </div>
</mc-window>

<!-- Routing Tool -->
<mc-window #routingWindow title="Routing" width="300" top="65" left="175" is-draggable="true">
    <mc-routing #routing slot="content"></mc-routing>
</mc-window>

<!-- Reports -->
<mc-window #reportsListWindow id="reportsListWindow" modal="true" title="Reports" is-resizable="true"
           is-draggable="true" height="700" width="760">
    <om-report-list slot="content"></om-report-list>
</mc-window>

<mc-window #reportsLauncherWindow id="reportsLauncherWindow" modal="true" title="Reports" is-resizable="true"
           is-draggable="true" height="700" width="760">
</mc-window>

<!-- Bookmarks -->
<mc-window #bookmarksWindow is-resizable="false" title="Bookmarks" is-draggable="true" height="583" width="500">
    <mc-bookmark #bookmarks slot="content" app-name="Maintenance_IQ"></mc-bookmark>
</mc-window>

<!-- User Settings -->
<mc-window #userSettingsWindow is-resizable="true" title="User Settings" is-draggable="true" height="583" width="500">
    <mc-user-settings #userSettings slot="content" app-name="OneMap"></mc-user-settings>
</mc-window>

<!-- Video Log -->
<mc-window #videoLogWindow title="Video Log" top="50" left="200" width="650" height="780" is-draggable="true" is-resizable="true" is-maximizable="true" style="position:relative; overflow-y: scroll;">
    <div slot="content" style="margin: -16px;">
        <div style="position: relative; height: 60%; margin-bottom: 30px;">
            <mc-video-log-viewer #videoLog buffer="1100" [markerSymbol]="markerSymbol" zoom-on-position-change="first"></mc-video-log-viewer>
            <mc-video-log-controller #videoLogController allow-zoom-type-change="true"></mc-video-log-controller>
        </div>
            <mc-video-log-info></mc-video-log-info>
    </div>
</mc-window>

<!-- Street View -->
<mc-window #streetViewWindow title="Street View" width="600" height="500" is-draggable="true" is-resizable="true">
    <mc-street-view #streetView slot="content" lat="40.263001" long="-76.884089">
        <div slot="widget-group" class="widget-group">
            <mc-rms-select slot="rms-select" #rmsSelect></mc-rms-select>
            <mc-lat-long-select slot="lat-long-select" #latLongSelect></mc-lat-long-select>
        </div>
    </mc-street-view>
</mc-window>

<!-- PETL -->
<mc-window #petlWindow title="PETL" width="95%" height="95%" modal="true">
    <mc-petl #petl slot="content" zoom-to-layer="true" enable-map-file-drop="true" (onfiledrop)="openPetl($event)" (onpetlclose)="closePetl($event)"></mc-petl>
</mc-window>

<mc-window #calloutToolWindow is-resizable="true" title="Callout Box" is-draggable="true" height="583" width="500">
    <mc-callout #calloutTool slot="content"></mc-callout>
</mc-window>
<!-- About -->
<mc-window #aboutWindow modal="true" title="About" [width]="650" [height]="650">
    <div slot="content">
        <h3>PennDOT One Map</h3>
        <p><a href="static/whatsNew.html" target="_blank">Version 2.16 - What's New</a></p>
        <p>
            Welcome to One Map, a system designed for the Pennsylvania Department of Transportation (PennDOT) to support
            the provision of improvements to state highways and bridges, as well as to aviation, public transit, and
            rail freight modes of transportation.
        </p>
        <p>
            The One Map application is a web-based GIS mapping application for highway and bridge projects on the
            Commonwealth's Twelve Year Transportation Program and Regional Transportation Improvement Plans (TIPs). This
            application allows users to map and obtain information for highway and bridge projects, and to search these
            projects by criteria such as:
        </p>
        <ul>
            <li>Location</li>
            <li>Planning partner</li>
            <li>Legislative district</li>
            <li>PennDOT engineering district</li>
            <li>Highway Occupancy Permits (HOPS)</li>
        </ul>
        <p>
            Projects can also be mapped individually by MPMS Project ID number or by Bridge Key.
        </p>
        <hr>
        <p>
            Environmental layer information can be viewed here: <a href="static/Metadata.xlsx" target="_blank">Download spreadsheet</a>
        </p>
        <p>
            View the Deep Link documentation here: <a href="static/deepLinkInfo.html" target="_blank">Deep Links</a>
        </p>
    </div>
</mc-window>

<!-- Contact -->
<mc-window #contactWindow modal="true" title="Contact Us" is-resizable="false" [width]="650" [height]="400">
    <div slot="content">
        <p>
            Please feel free to contact a representative with any questions, comments or issues at the following email
            address:
        </p>
        <a (click)="closeContactWindow()" href="mailto:RA-PDPENNDOT_GIS@pa.gov">RA-PDPENNDOT_GIS@pa.gov</a>
    </div>
</mc-window>

<!-- AOI -->
<mc-window #aoiToolWindow id="aoiToolWindow" modal="true" title="Select an Area of Interest" width="875">
    <div slot=content>
        <om-aoi-tool #aoiTool [mapRef]="mapRef" [loggedIn]="loggedIn" (shouldLogIn)="logInOrOut($event)"></om-aoi-tool>
    </div>
</mc-window>

<!-- Draw Tools -->
<mc-window #drawToolWindow id="draw-tool-window" title="Draw Tool" is-draggable="true" is-resizable="true" [top]="drawToolTop"
           [width]="drawToolWidth" [maxHeight]="maxHeight">
    <om-draw-tool #drawTool id="draw-tool" slot="content"></om-draw-tool>
</mc-window>

<!-- Reset -->
<mc-window #resetMapWindow id='reset-map-window' title="Reset Map" modal="true">
    <div slot="content">
        <p>Are you sure you would like to reset your map?</p>
        <div class="reset-button-group flex-display flex-row">
            <button class="btn reset-button" (click)="resetMap()">Yes</button>
            <button class="btn reset-button btn-clear" (click)="closeResetMap()">No</button>
        </div>
    </div>
</mc-window>

<!-- Error message -->
<mc-window #errorWindow id="error-window" title="Error" modal="true">
    <div slot="content">
        <p>{{ errorMessage }}</p>
        <button class="btn right" (click)="closeErrorWindow()">OK</button>
    </div>
</mc-window>

<mc-auth #auth [attr.auth-url]="pdauthURL" app-name="OneMap" show-user="false" prefix="Logged in as "></mc-auth>

<!-- Header -->
<header class="block-display width-wrap">
    <nav class="flex-display width-wrap" aria-label="Top Menu">
        <a class="logo clickable flex-shrink" (click)="openResetMap()">
            <img src="assets/penndot_logo_glow.png"
                 alt="PennDOT OneMap" />
        </a>
        <div class="navRight flex-grow flex-display">
            <button class="btn icon-ui-search" (click)="toggleSearchTips($event)"></button>
            <om-search-tips #searchTips></om-search-tips>
            <mc-search id="search" #search slot="top-right" max-results="250" add-selection-to-map="true" (onresultselected)="searchResultSelected($event)"></mc-search>
            <button (click)="openMapCatalog($event)" class="btn btn-clear">Maps</button>
            <button (click)="openLayerCatalog($event)" class="btn btn-clear">Layers</button>
            <button (click)="openAoiTool()" class="btn btn-clear">Change Area of Interest</button>
            <div class="dropdown js-dropdown">
                <button class="btn btn-clear dropdown-btn js-dropdown-toggle" tabindex="0" aria-haspopup="true"
                        aria-expanded="false">
                    Tools <span class="icon-ui-down-arrow icon-ui-flush"></span>
                </button>
                <nav class="dropdown-menu dropdown-right" role="menu" aria-label="Tools Menu">
                    <button (click)="openDrawTool($event)" class="dropdown-link btn btn-transparent" role="menuitem">
                        <span class="icon-ui-edit"></span> Draw Tool
                    </button>
                    <button (click)="openMeasureTools($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-line-chart"></span> Measurement
                    </button>
                    <button (click)="openRouting($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-navigation"></span> Routing
                    </button>
                    <button (click)="openStreetView($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-map-pin"></span> Street View
                    </button>
                    <button (click)="openVideoLog($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-play"></span> Video Log
                    </button>
                    <button (click)="openReportsList()" class="dropdown-link btn btn-transparent" role="menuitem">
                        <span class="icon-ui-documentation"></span> Reports
                    </button>
                    <button (click)="showOverview = !showOverview" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-maps"></span> Overview
                    </button>
					<button (click)="openCalloutTool($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-chat"></span> Callout Box Tool
                    </button>
                    <button (click)="openPetl($event)" class="dropdown-link btn btn-transparent" role="menuitem" [ngStyle]="{'display': isLoggedIn ? '' : 'none'}">
                        <span class="icon-ui-table"></span> PETL
                    </button>
                    <button (click)="openTIRe($event)" class="dropdown-link btn btn-transparent" role="menuitem" [class.rms]="rms">
                        <span class="icon-ui-link-external"></span> TIRe {{ rmsSnippet }}
                    </button>
                </nav>
            </div>

            <!-- User Info -->
            <div class="dropdown js-dropdown">
                <button class="btn btn-clear dropdown-btn js-dropdown-toggle" tabindex="0" aria-haspopup="true"
                        aria-expanded="false">
                    <i class="icon-ui-user" [ngClass]="{'icon-ui-green': isLoggedIn}"></i> <span class="icon-ui-down-arrow icon-ui-flush"></span>
                </button>
                <nav class="dropdown-menu dropdown-right" role="menu" aria-label="User Menu">
                    <span class="dropdown-link btn" [ngStyle]="{'display': isLoggedIn ? '' : 'none'}">
                        <i class="icon-ui-user"></i> Logged in as {{ userName }}
                    </span>
                    <button (click)="logInOrOut($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-user" [ngClass]="{'icon-ui-dark-blue': isLoggedIn}"></span>{{ isLoggedIn ? 'Log Out' : 'Log In' }}
                    </button>
                    <button (click)="openUserSettings($event)" class="dropdown-link btn" role="menuitem" [ngStyle]="{'display': isLoggedIn ? '' : 'none'}">
                        <span class="icon-ui-settings2"></span> User Settings
                    </button>
                    <button (click)="openBookmarks($event)" class="dropdown-link btn" role="menuitem">
                        <span class="icon-ui-tag"></span> Bookmarks
                    </button>
                </nav>
            </div>

            <!-- Site Info -->
            <div class="dropdown js-dropdown">
                <button class="btn btn-clear dropdown-btn js-dropdown-toggle" tabindex="0" aria-haspopup="true"
                        aria-expanded="false">
                    <i class="icon-ui-description"></i> <span class="icon-ui-down-arrow icon-ui-flush"></span>
                </button>
                <nav class="dropdown-menu dropdown-right" role="menu" aria-label="About / Help / Contact Us">
                    <button (click)="openAboutWindow()" class="dropdown-link btn" role="menuitem">
                        <i class="icon-ui-description"></i> About
                    </button>
                    <a href="static/webHelp/Welcome.htm" target="_blank" class="dropdown-link"
                       role="menuitem"><span class="icon-ui-question"></span>Help</a>
                    <button (click)="openContactWindow()" class="dropdown-link btn" role="menuitem">
                        <i class="icon-ui-contact"></i> Contact Us
                    </button>
                </nav>
            </div>
        </div>
    </nav>
</header>
